import axios from '@/libs/api.request'

/**
 * 添加加密狗用户
 */
export const bindCryptoUser = (code, user_ids) => {
    const data ={
        "code": code,
        "user_ids": user_ids
    }
    return axios.request({
        url: '/api/admin/cryptodog/bindUser',
        data,
        method: 'post'
    })
}

/**
 * 解绑加密狗用户
 */
export const unBindCryptoUser = (code, user_ids) => {
    const data ={
        "code": code,
        "user_ids": user_ids
    }
    return axios.request({
        url: '/api/admin/cryptodog/unBindUser',
        data,
        method: 'post'
    })
}